


























import { Vue, Component } from "vue-property-decorator";
import ContractorForm from "@/components/contractors/ContractorForm.vue";
import { ContractorNew as IContractorNew } from "@/api/models/contractor-new";
import api from "@/getinfo-api";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import ContractorFormV2 from "@/components/contractors/ContractorFormV2.vue";

@Component({
  components: { ContractorFormV2, ContractorForm }
})
export default class ContractorEdit extends Vue {
  contractor!: IContractorNew;

  data() {
    return {
      contractor: undefined
    };
  }

  mounted() {
    api.ContractorApi.getContractorNew(this.$route.params.contractorId)
      .then((res: { data: IContractorNew }) => {
        this.contractor = res.data;
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }
}
